/**
 * @author：
 * @update：
 * @description：
 **/
import {role,cattalogs} from "../../api/url"
import treeDataModel from "../../components/treeDataModel2/index.vue"
export default {
    components:{
        'tree-model':treeDataModel
    },
    data() {
        return {
            isOpen:true,
            isSealing:true,
            phoneNumber:null,
            subName:'',
            contentData: [],
            multipleSelection: [],
            page:1,//页数
            count:100,//总条数
            size:10,
            loading: false,//加载loading
            isEnable:[{
                value: '',
                label: '全部'
            },{
                value: 'true',
                label: '启用'
            },{
                value: 'false',
                label: '停用'
            }],
            isEnableValue:'',
            isLocked:[{
                value: '',
                label: '全部'
            },{
                value: 'false',
                label: '解封'
            },{
                value: 'true',
                label: '封停'
            }],
            isLockedValue:'',

            //高级搜索
            searchBol:false,
            searchName:'',//高级搜索名称
            searchDescribe:'',//高级搜索描述
            isUsing:true,//是否启用
            isClosure:false,//是否封停.
            searchTime:'',//创建时间
            openCheckbox:false,//接口的权限展开
            openCheckbox2:false,//菜单的权限展开
            isIndeterminate:false,//接口权限的全选
            isIndeterminate2:false,//菜单权限的全选
            checkAll:false,//
            checkAll2:false,
            checkAllData:[],//全选时需要的数据
            checkAllData2:[],//全选时需要的数据
            checkedCities: [],//接口权限的选中的数据
            checkedCities2:[],//菜单权限的全选
//region
            //新建
          isClick:true,//防抖
            isAdd:true,//新建true 编辑false
            newUser:false,
            addUserName:'',//新建用户名字
            userDescribe:'',//资源描述

            //接口权限
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            interfaceBol:false,
            filterText:'',//搜索
            //树状图数据
            treeData:[],
            checkDataes:[],//原本权限
            checkData:[],//已选中权限
            checkedKey:[],//已选中回显的key
            interfaceId:'',//要修改的权限id
            jurisdictionDel:[],//批量删除的权限
            jurisdictionDel2:[],//删除全选时的所有权限

            //访问权限
            visitBol:false,
            //树状图数据
            visitData:[],
            visitcheckDataes:[],//原本权限
            visitcheckData:[],//已选中权限
            visitinterfaceId:'',//要修改的权限id
            visitjurisdictionDel:[],//批量删除的权限
            visitjurisdictionDel2:[],//删除全选时的所有权限
            //endregion

            deleteBol:false,

            resourceName:'',

            delListBol:false,//是否显示多选框
            leftData:[],//左侧内容
            rightData:[],//右侧内容
            dataAllList:[],//要删除的内容
            LeftCount:0,//左侧数据个数
            leafContent:[],

        };
    },
    // 自定义方法
    methods: {
        //搜索
        searchBtn(){
            this.page=1;
            this.roleList();
        },
        //搜索重置
        searchReset(){
            this.subName='';
            this.isEnableValue='';
            this.isLockedValue='';
            this.searchBtn();
        },
        //全选
        searchAllChange(val) {
            let data = [];
            for(let i = 0; i < this.checkAllData.length; i++){
                data.push(this.checkAllData[i].id)
            }
            this.checkedCities = val ? data : [];
            this.isIndeterminate = false;
        },
        searchAllChange2(val) {
            let data = [];
            for(let i = 0; i < this.checkAllData2.length; i++){
                data.push(this.checkAllData2[i].id)
            }
            this.checkedCities2 = val ? data : [];
            this.isIndeterminate2 = false;
        },
        //全选下内容选择
        checkSelect(value){
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.checkAllData.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkAllData.length;
        },
        checkSelect2(value){
            let checkedCount = value.length;
            this.checkAll2 = checkedCount === this.checkAllData2.length;
            this.isIndeterminate2 = checkedCount > 0 && checkedCount < this.checkAllData2.length;
        },

        //接口权限
        jurisdiction(id,name){
            this.interfaceId = id;
            this.resourceName = name;
            new Promise((resolve,reject)=> {
                //左侧全部权限
                let data = {
                    type:'API'
                };
                this.leafContent = [];//保证每次打开弹窗都是最新的叶子数据
                this.$ajax.get(cattalogs,data).then(res=>{
                    console.log(res.data);
                    // let str = JSON.stringify(res.data).replace(/"name":/g,'"label":');
                    // this.treeData = JSON.parse(str);
                    let dataContent = res.data;
                    for(let i = 0; i < dataContent.length; i++){
                        dataContent[i].label = dataContent[i].name;
                        this.mapChildren(dataContent[i].children);
                    }
                    this.treeData = dataContent;
                    resolve('success');
                }, (err) => {
                    console.log(err);
                    reject('error');
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                });
            }).then((res)=>{
                return new Promise((resolve,reject)=> {
                    //右侧已有的权限
                    this.$ajax.get(role+'/'+id+'/authorities').then((res)=>{
                        console.log(res);
                        let data = [];
                        for (let i = 0; i < res.data.length; i++) {
                            let obj = {};
                            obj.label = res.data[i].name;
                            obj.id = res.data[i].id;
                            obj.name =  res.data[i].name;
                            obj.description =  res.data[i].description;
                            obj.scope = res.data[i].scope;
                            data.push(obj);
                        }
                        this.checkDataes = data;
                        resolve('success');
                    },(err)=>{
                        console.log(err);
                        reject('error');
                        if(err.status === 403){
                            this.$message({
                                showClose: true,
                                message: '当前账号没有权限',
                                type: 'error',
                                center: true,
                                duration: 3000
                            })
                        }else if (err.status === 500) {
                            this.$message({
                                showClose: true,
                                message: '服务器异常',
                                type: 'error',
                                center: true,
                                duration: 3000
                            })
                        }else if (err.status === 502) {
                            this.$message({
                                showClose: true,
                                message: '服务器异常',
                                type: 'error',
                                center: true,
                                duration: 3000
                            })
                        }
                    });
                });
            }).then((res)=>{
                if(res=='success'){
                    this.jurisdictionDel2=[];
                    this.interfaceBol=true;
                }
            });
        },
        //关闭权限框
        modelClose(){
            this.interfaceBol=false;
        },
        //提交
        interfaceBtn(data){
            let dataId = [];
            for(let i = 0; i < data.length; i++){
                dataId.push(data[i].id)
            }
            this.$ajax.post(role+'/'+this.interfaceId+'/authorities',dataId).then((res)=>{
                console.log(res);
                this.interfaceBol = false;
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            },(err)=>{
                console.log(err);
                this.$message({
                    showClose: true,
                    message: err.data,
                    type: 'error',
                    center: true,
                    duration: 3000
                });
            })
        },
        //接口删除
        delMoreList(data){
            this.$ajax.delete(role+'/'+this.interfaceId+'/authorities',data).then((res)=>{
                console.log(res);
                this.interfaceBol = false;
                this.$message({
                    showClose: true,
                    message: "修改成功",
                    type: 'success',
                    center: true,
                    duration: 3000
                });
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            })
        },

        mapChildren(data){
            for(let i in data){
                data[i].label = data[i].name;
                if(data[i].authorities){
                    console.log(data[i].authorities)
                    if(data[i].children) {
                        data[i].children = {...data[i].children,...data[i].authorities}
                    }else{
                        data[i].children = data[i].authorities
                    }
                    this.LeftCount = this.LeftCount + data[i].authorities.length;
                    this.leafContent = [...this.leafContent,...data[i].authorities];
                }
                if(data[i].children){
                    this.mapChildren(data[i].children);
                }
            }
        },





        //访问权限
        visitjurisdiction(id,name){
            this.interfaceId = id;
            this.resourceName = name;
            new Promise((resolve,reject)=> {
                //左侧全部权限
                let data = {
                    type:'MENU'
                };
                this.leafContent = [];//保证每次打开弹窗都是最新的叶子数据
                this.$ajax.get(cattalogs,data).then(res=>{
                    console.log(res.data);
                    let dataContent = res.data;
                    for(let i = 0; i < dataContent.length; i++){
                        dataContent[i].label = dataContent[i].name;
                        this.mapChildren2(dataContent[i].children);
                    }
                    this.visitData = dataContent;
                    resolve('success');
                }, (err) => {
                    console.log(err);
                    reject('error');
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                });
            }).then((res)=>{
                return new Promise((resolve,reject)=> {
                    //右侧已有的权限
                    this.$ajax.get(role + '/' + id + '/accesses').then((res) => {
                        console.log(res);
                        let data = [];
                        for(let i = 0; i <res.data.length; i++){
                            let obj = {};
                            obj.label = res.data[i].name;
                            obj.id = res.data[i].id;
                            obj.name =  res.data[i].name;
                            obj.description =  res.data[i].description;
                            data.push(obj);
                        }
                        this.visitcheckDataes = data;
                        resolve('success');
                    }, (err) => {
                        console.log(err);
                        reject('error');
                        if(err.status === 403){
                            this.$message({
                                showClose: true,
                                message: '当前账号没有权限',
                                type: 'error',
                                center: true,
                                duration: 3000
                            })
                        }else if (err.status === 500) {
                            this.$message({
                                showClose: true,
                                message: '服务器异常',
                                type: 'error',
                                center: true,
                                duration: 3000
                            })
                        }else if (err.status === 502) {
                            this.$message({
                                showClose: true,
                                message: '服务器异常',
                                type: 'error',
                                center: true,
                                duration: 3000
                            })
                        }
                    });
                })
            }).then((res)=>{
                if(res=='success'){
                    this.visitjurisdictionDel2=[];
                    this.visitBol=true;
                }
            });
        },
        //关闭权限框
        visitmodelClose(){
            this.visitBol=false;
        },
        //提交
        visitinterfaceBtn(data){
            let dataId = [];
            for(let i = 0; i < data.length; i++){
                dataId.push(data[i].id)
            }
            this.$ajax.post(role+'/'+this.interfaceId+'/accesses',dataId).then((res)=>{
                console.log(res);
                this.visitBol = false;
                this.$message({
                    showClose: true,
                    message: "修改成功",
                    type: 'success',
                    center: true,
                    duration: 3000
                });
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            })
        },
        //接口删除
        visitdelMoreList(data){
            this.$ajax.delete(role+'/'+this.interfaceId+'/accesses',data).then((res)=>{
                console.log(res);
                this.visitBol = false;
                this.$message({
                    showClose: true,
                    message: "修改成功",
                    type: 'success',
                    center: true,
                    duration: 3000
                });
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            })
        },
        mapChildren2(data){
            for(let i in data){
                data[i].label = data[i].name;
                if(data[i].type==undefined){
                    data[i].type = "MENUS";
                }
                if(data[i].accesses){
                    if(data[i].children) {
                        data[i].children = {...data[i].children,...data[i].accesses}
                    }else{
                        data[i].children = data[i].accesses
                    }
                    this.LeftCount = this.LeftCount + data[i].accesses.length;
                    this.leafContent = [...this.leafContent,...data[i].accesses];
                }
                if(data[i].children){
                    this.mapChildren2(data[i].children);
                }
            }
        },



        //列表数据
        roleList(){
            this.loading = true;
            let data = {
                name:this.subName,
                pageNumber:this.page,
                enabled:this.isEnableValue,
                locked:this.isLockedValue,
                pageSize:this.size
            };
            this.$ajax.get(role,data).then((res)=>{
                console.log(res);
                this.contentData = res.data.rows;
                this.count = res.data.total;
                this.loading = false;
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //高级搜索
        moreSearch(){
            this.searchBol = true;
        },
        //分页器
        currentChange(page){
            this.page = page;
            this.contentData=[];
            this.roleList();
        },
        //新建用户
        addUser(){
            this.resetBtn();
            this.newUser = true;
            this.isAdd = true;
        },
        //重置
        resetBtn(){
            this.addUserName='';
            this.userDescribe='';
        },
        //取消
        cancelBtn(){
            this.addUserName='';
            this.userDescribe='';
            this.newUser = false;
        },
        //提交
        submitBtn(){
            if(this.isAdd){
                if(this.addUserName==''){
                    this.$message({
                        showClose: true,
                        message: "角色名称不可为空！",
                        type: 'error',
                        center: true,
                        duration: 3000
                    });
                    return false
                }
                if(this.userDescribe==''){
                    this.$message({
                        showClose: true,
                        message: "角色描述不可为空！",
                        type: 'error',
                        center: true,
                        duration: 3000
                    });
                    return false
                }
                //新建提交
              if(this.isClick){
                this.isClick = false;
                let data = {
                  description: this.userDescribe,
                  name: this.addUserName
                };
                this.$ajax.post(role,data).then((res)=>{
                  console.log(res);
                  this.roleList();
                  this.addUserName='';
                  this.userDescribe='';
                  this.newUser = false;
                  this.isClick = true;
                  this.$message({
                    showClose: true,
                    message: "新建成功",
                    type: 'success',
                    center: true,
                    duration: 3000
                  });
                },(err)=>{
                  console.log(err);
                  this.isClick = true;
                  if(err.status === 403){
                    this.$message({
                      showClose: true,
                      message: '当前账号没有权限',
                      type: 'error',
                      center: true,
                      duration: 3000
                    })
                  }else if (err.status === 500) {
                    this.$message({
                      showClose: true,
                      message: '服务器异常',
                      type: 'error',
                      center: true,
                      duration: 3000
                    })
                  }else if (err.status === 502) {
                    this.$message({
                      showClose: true,
                      message: '服务器异常',
                      type: 'error',
                      center: true,
                      duration: 3000
                    })
                  }
                })
              }

            }else{
                if(this.addUserName==''){
                    this.$message({
                        showClose: true,
                        message: "角色名称不可为空！",
                        type: 'error',
                        center: true,
                        duration: 3000
                    });
                    return false
                }
                if(this.userDescribe==''){
                    this.$message({
                        showClose: true,
                        message: "角色描述不可为空！",
                        type: 'error',
                        center: true,
                        duration: 3000
                    });
                    return false
                }
                //编辑提交
                let id = this.multipleSelection[0].id;
                let data = {
                    description: this.userDescribe,
                    id:id,
                    name: this.addUserName
                };
                this.$ajax.put(role + '/' + id, data).then((res) => {
                    console.log(res);
                    this.roleList();
                    this.addUserName = '';
                    this.userDescribe = '';
                    this.newUser = false;
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: 'success',
                        center: true,
                        duration: 3000
                    });
                }, (err) => {
                    console.log(err);
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                })
            }

        },
        //删除
        delUser(){
            if(this.multipleSelection.length==0){
                this.$message({
                    showClose: true,
                    message: '至少选择一条要删除的数据',
                    type: 'error',
                    center: true,
                    duration: 3000
                });
            }else{
                this.deleteBol=true;
            }
        },
        dataListDel(){
            if(this.multipleSelection.length==1){
                let id = this.multipleSelection[0].id;
                this.$ajax.delete(role+"/"+id).then((res)=>{
                    console.log(res);
                    this.deleteBol=false;
                    this.roleList();
                    this.$message({
                        showClose: true,
                        message: "删除成功",
                        type: 'success',
                        center: true,
                        duration: 3000
                    });
                },(err)=>{
                    console.log(err);
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                })
            }else if(this.multipleSelection.length>1){
                let data = [];
                for(let i = 0; i < this.multipleSelection.length; i++){
                    data.push(this.multipleSelection[i].id)
                }
                this.$ajax.delete(role,data).then((res)=>{
                    console.log(res);
                    this.deleteBol=false;
                    this.roleList();
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: 'success',
                        center: true,
                        duration: 3000
                    });
                },(err)=>{
                    console.log(err);
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                })
            }
        },
        //编辑
        editUser(){
            if(this.multipleSelection.length==0){
                this.$message({
                    showClose: true,
                    message: '请选择一条数据',
                    type: 'error',
                    center: true,
                    duration: 3000
                });
            }else if(this.multipleSelection.length>1){
                this.$message({
                    showClose: true,
                    message: '一次只能编辑一条数据',
                    type: 'error',
                    center: true,
                    duration: 3000
                });
            }else {
                let id = this.multipleSelection[0].id;
                this.$ajax.get(role + '/' + id).then((res) => {
                    console.log(res);
                    this.addUserName = res.data.name;
                    this.userDescribe = res.data.description;
                    this.newUser = true;
                    this.isAdd = false;
                }, (err) => {
                    console.log(err);
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                })
            }
        },

        //列表开关点击 val:false当前为关闭 true当前为开启 id:要修改的数据 type:0是否启用 1是否锁定
        isSwitch(val,id){
            if (!val) {
                //启用
                this.$ajax.put(role+'/'+id+'/enable').then((res)=>{
                    console.log(res);
                    this.roleList();
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: 'success',
                        center: true,
                        duration: 3000
                    });
                },(err)=>{
                    console.log(err);
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                })
            } else {
                //关闭
                this.$ajax.put(role+'/'+id+'/disable').then((res)=>{
                    console.log(res);
                    this.roleList();
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: 'success',
                        center: true,
                        duration: 3000
                    });
                },(err)=>{
                    console.log(err);
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                })
            }
        },
        isSwitch2(val,id){
            if (!val) {
                //启用
                this.$ajax.put(role+'/'+id+'/lock').then((res)=>{
                    console.log(res);
                    this.roleList();
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: 'success',
                        center: true,
                        duration: 3000
                    });
                },(err)=>{
                    console.log(err);
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                })
            } else {
                //关闭
                this.$ajax.put(role+'/'+id+'/unlock').then((res)=>{
                    console.log(res);
                    this.roleList();
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: 'success',
                        center: true,
                        duration: 3000
                    });
                },(err)=>{
                    console.log(err);
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                })
            }
        },

        delOpen(fun,id) {
            this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                fun(id);
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });
        },
        //我的手机号验证
        myPhone(val){
            this.phoneNumber=val.replace(/\D/g,'')
        }
    },
    // 数据观察监听
    watch: {
        addUserName(newData,oldData){
            if(newData == ''){
                return
            }
            //正则表达式
            let reg = new RegExp("^[\\u4e00-\\u9fa5a-zA-Z0-9]{1,32}$");
            //判断输入框中有内容
            if(!reg.test(newData)){
                this.$message({
                    showClose: true,
                    message: '角色名称只能包含中文英文和数字！',
                    type: 'error',
                    center: true,
                    duration: 3000
                })
                this.addUserName = oldData
            }
        }
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {
        this.roleList()
    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
